module.exports = __webpack_public_path__ + "returns-grid.2020ae645da200070a3f2d3c81ba15b8.png";